import { render, staticRenderFns } from "./sendToFuture.vue?vue&type=template&id=4b96b27d&scoped=true"
import script from "./sendToFuture.vue?vue&type=script&lang=js"
export * from "./sendToFuture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96b27d",
  null
  
)

export default component.exports